<script>
import MkContact from "@/components/mk/MkContact.vue";
import EnContact from "@/components/en/EnContact.vue";
import AlContact from "@/components/al/AlContact.vue";
export default {
  components:{MkContact, EnContact, AlContact},
  name: "ContactPage",
  data(){
    return {
      lang: "mk"
    }
  },
  methods: {
    changeLang(language){
      this.lang = language;
    }
  }
}
</script>

<template>
  <div class="main">
    <v-card class="card">
      <v-card-actions class="justify-center">
        <v-btn class="button" @click="changeLang('mk')"
        ><img :src="require('../assets/mkflag.svg')" alt="MK"
        /></v-btn>
        <v-btn class="button" @click="changeLang('en')"
        ><img :src="require('../assets/ukflag.svg')" alt="EN"
        /></v-btn>
        <v-btn class="button" @click="changeLang('al')"
        ><img :src="require('../assets/alflag.svg')" alt="AL"
        /></v-btn>
      </v-card-actions>
    </v-card>
    <transition name="fade-card" mode="out-in">
      <mk-contact v-if="lang === 'mk'"></mk-contact>
      <en-contact v-else-if="lang === 'en'"></en-contact>
      <al-contact v-else-if="lang === 'al'"></al-contact>
    </transition>
  </div>
</template>

<style scoped>
img{
  max-width: 30px;
}
.card{
  border-radius: 12px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.99);
  padding: 0.3rem;
  margin: 2rem auto;
  max-width: 18rem;
  text-align: center;
}
.main{
  min-height: 100vh;
  background: transparent;
}
.button{
  background-color: bisque;
  color: white;
}

.fade-card-enter-from,
.fade-card-leave-to {
  opacity: 0;
}
.fade-card-enter-active {
  transition: all 0.4s ease-out;
}
.fade-card-leave-active {
  transition: all 0.4s ease-in;
}

.fade-card-enter-to,
.fade-card-leave-from {
  opacity: 1;
}
</style>